module.exports = __webpack_public_path__ + "img/hp-three-3.e3e98a80.jpg";